export default __webpack_public_path__ + "static/media/arrowForwardHelp.a6490f7e.png";